import config from '../../config';
import { pathResolver } from './basePathHelper';
const pathTermsAndConditions = 'resources/termsAndConditions/';
const pathPrivacyPolicy = 'resources/privacyPolicy/';
export function getTermsAndConditionsPath(locale) {
  let termsAndConditionsFile = 'CGU - PanDA OFA.pdf';
  if (locale === 'fr') {
    termsAndConditionsFile = 'CGU - PanDA OFA.pdf';
  }
  return pathResolver(pathTermsAndConditions + termsAndConditionsFile);
}
export function getPrivacyPolicyPath(locale) {
  let privacyPolicyFile = 'OFA-Politique-de-confidentialite-v2.pdf';
  if (locale === 'fr') {
    privacyPolicyFile = 'OFA-Politique-de-confidentialite-v2.pdf';
  }
  return pathResolver(pathPrivacyPolicy + privacyPolicyFile);
}
export function getNewsUrlFromLocale(locale) {
  if (locale === 'fr') {
    return config.blogUrl;
  }
  return null;
}
export function getOrigin() {
  if (config.isMicrofront) {
    return `${window.location.origin}/${window.location.pathname.split('/').filter(Boolean)[0]}`;
  }
  return window.location.origin;
}